import apiClient from '../../../../shared/infrastructure/api/client';
import { ChatMessage, ChatHistoryResponse } from '../../domain/PatientChat';

export const CouplePatientChatHistoryApiService = {
  load: async (couplePatientId: string): Promise<ChatMessage[]> => {
    const res = await apiClient.get<ChatHistoryResponse>(`/couple-patients/${couplePatientId}/chat-history`);
    return res.data.messages;
  },

  save: async (couplePatientId: string, messages: ChatMessage[]): Promise<void> => {
    await apiClient.put(`/couple-patients/${couplePatientId}/chat-history`, { messages });
  },
};
